import { DocumentNode } from 'graphql'
import { isSubscriptionOperation } from '@apollo/client/utilities'

export function defaultSubscriptionOptionsToResubscribe<T>(options: T, documentNode: DocumentNode) {
  return isSubscriptionOperation(documentNode) ? { shouldResubscribe: true, ...options } : options
}
